import React from 'react';
import { HStack } from '@saucelabs/sl-component-grid';
import { Typography } from '@saucelabs/ds-typography';
import { IconAutomatedOutline, IconCreditCardOutline } from '@saucelabs/ds-icons';
import amexCardIcon from '@saucelabs/sl-icons/lib/icn-credit-card-amex.png';
import dinersCardIcon from '@saucelabs/sl-icons/lib/icn-credit-card-diners.png';
import discoverCardIcon from '@saucelabs/sl-icons/lib/icn-credit-card-discover.png';
import jcbCardIcon from '@saucelabs/sl-icons/lib/icn-credit-card-jcb.png';
import mastercardCardIcon from '@saucelabs/sl-icons/lib/icn-credit-card-mastercard.png';
import visaCardIcon from '@saucelabs/sl-icons/lib/icn-credit-card-visa.png';

interface Props {
  creditCardInfo: CreditCardInfo,
}

const CreditCardReadOnly: React.FC<Props> = ({ creditCardInfo }) => {
  const cardImage = {
    'American Express': amexCardIcon,
    'Diners Club': dinersCardIcon,
    Discover: discoverCardIcon,
    JCB: jcbCardIcon,
    MasterCard: mastercardCardIcon,
    Visa: visaCardIcon,
  }[creditCardInfo.cardType];

  return (
    <HStack
      alignItems="flex-end"
      justifyContent="flex-start"
    >
      {cardImage ? (
        <img
          alt="Card"
          className="mr-1"
          height={24}
          src={cardImage}
          width={36}
        />
      ) : (
        <IconCreditCardOutline
          className="mr-1 fill-current text-gray-500"
          height="20"
        />
      )}
      <div>
        <Typography
          className="text-high-emphasis"
          component="span"
        >
          {`•••• •••• •••• ${creditCardInfo.lastFour} `}
        </Typography>
        <Typography
          className="text-medium-emphasis"
          component="span"
          variant="body-small"
        >
          {`(Expire ${creditCardInfo.expires})`}
        </Typography>
      </div>
    </HStack>
  );
};

export default CreditCardReadOnly;
